import { render, staticRenderFns } from "./CmgLoyaltyProgressWallet.vue?vue&type=template&id=bd8a8444&scoped=true&lang=pug"
import script from "./cmg-loyalty-progress-wallet.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-progress-wallet.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyProgressWallet.vue?vue&type=style&index=0&id=bd8a8444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8a8444",
  null
  
)

export default component.exports